import script from "./JaContentSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentSelect.vue?vue&type=script&setup=true&lang=js"

import "./JaContentSelect.vue?vue&type=style&index=0&id=7047de78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7047de78"]])

export default __exports__